import {
  IconAddressBook,
  IconAlarmPlus,
  IconArrowLeft,
  IconArrowsDiff,
  IconBinaryTree2,
  IconBriefcase2,
  IconCircleCheck,
  IconClipboardText,
  IconClock,
  IconCopy,
  IconCube,
  IconFileDescription,
  IconGeometry,
  IconHelp,
  IconInfoCircle,
  IconLink,
  IconListCheck,
  IconListNumbers,
  IconMail,
  IconPencilDollar,
  IconSitemap,
  IconStopwatch,
  IconUserDollar,
  IconUsers,
} from '@tabler/icons-react';
import { INavigationMenu } from 'src/app/navigation/navigationTypes';
import { ProgressViewerScopes } from 'src/data/scopes';

export const jobItems: INavigationMenu = {
  items: [
    {
      id: 'back-settings',
      type: 'group',
      children: [
        {
          allowAll: true,
          id: 'back',
          title: 'Back to Dashboard',
          type: 'item',
          url: '/ctc',
          icon: <IconArrowLeft size={22} />,
          keepDrawerOpen: true,
        },
      ],
    },
    {
      id: 'group-job-org',
      title: 'Organization',
      type: 'group',
      children: [
        {
          id: 'summary',
          title: 'Summary',
          type: 'item',
          isJob: true,
          requiredScopes: ['jobs_all', 'jobs_summary'],
          url: '/summary',
          icon: <IconBriefcase2 size={22} />,
        },
        {
          id: 'activity',
          title: 'Activity',
          requiredScopes: ['jobs_all', 'jobs_activity'],
          isJob: true,
          type: 'item',
          url: '/activity',
          icon: <IconAlarmPlus size={22} />,
        },
        {
          id: 'emails',
          requiredScopes: ['jobs_all', 'jobs_emails'],
          title: 'Emails',
          isJob: true,
          type: 'item',
          url: '/emails',
          icon: <IconMail size={22} />,
        },
        {
          id: 'progress',
          title: 'Progress',
          requiredScopes: ProgressViewerScopes,
          isJob: true,
          type: 'item',
          url: '/progress',
          icon: <IconListNumbers size={22} />,
        },
        {
          id: 'milestones',
          title: 'Milestones',
          requiredScopes: ['jobs_all', 'jobs_milestones'],
          isJob: true,
          type: 'item',
          url: '/milestones',
          icon: <IconCircleCheck size={22} />,
        },
        {
          id: 'meeting_minutes',
          requiredScopes: ['jobs_all', 'jobs_meeting_minutes'],
          title: 'Meeting Minutes',
          isJob: true,
          type: 'item',
          url: '/meetings',
          icon: <IconStopwatch size={22} />,
        },
        {
          id: 'tracker',
          title: 'Tracker',
          requiredScopes: ['jobs_all', 'jobs_tracker'],
          type: 'item',
          isJob: true,
          url: '/tracker',
          icon: <IconListCheck size={22} />,
        },
        {
          id: 'contacts',
          title: 'Contacts',
          isJob: true,
          requiredScopes: ['jobs_all', 'jobs_contacts'],
          type: 'item',
          url: '/contacts',
          icon: <IconAddressBook size={22} />,
        },
      ],
    },
    {
      id: 'group-job-ops',
      title: 'Operations',
      type: 'group',
      children: [
        {
          id: 'dailys',
          title: 'Dailys',
          type: 'item',
          requiredScopes: ['jobs_all', 'jobs_dailys'],
          isJob: true,
          url: '/dailys',
          icon: <IconClock size={22} />,
        },
        {
          id: 'work_tickets',
          title: 'Work Tickets',
          requiredScopes: ['jobs_all', 'jobs_work_tickets'],
          type: 'item',
          isJob: true,
          url: '/tickets',
          icon: <IconClipboardText size={22} />,
        },
        {
          id: 'changes',
          title: 'Changes',
          requiredScopes: ['jobs_all', 'jobs_changes'],
          type: 'item',
          isJob: true,
          url: '/changes',
          icon: <IconArrowsDiff size={22} />,
        },
        {
          id: 'timesheets',
          title: 'Timesheets',
          requiredScopes: ['jobs_all', 'jobs_timesheets'],
          type: 'item',
          isJob: true,
          url: '/timesheets',
          icon: <IconPencilDollar size={22} />,
        },
        {
          id: 'rfis',
          title: 'RFIs',
          requiredScopes: ['jobs_all', 'jobs_rfis'],
          type: 'item',
          isJob: true,
          url: '/rfis',
          icon: <IconInfoCircle size={22} />,
        },
      ],
    },
    {
      id: 'group-job-docs',
      title: 'Documents',
      type: 'group',
      children: [
        {
          id: 'documents',
          title: 'Documents',
          requiredScopes: ['jobs_all', 'jobs_documents'],
          type: 'item',
          isJob: true,
          url: '/documents',
          icon: <IconFileDescription size={22} />,
        },
        {
          id: 'transmittals',
          title: 'Transmittals',
          requiredScopes: ['jobs_all', 'jobs_transmittals'],
          type: 'item',
          isJob: true,
          url: '/transmittals',
          icon: <IconCopy size={22} />,
        },
        {
          id: 'drawings',
          title: 'Drawings',
          requiredScopes: ['jobs_all', 'jobs_drawings'],
          type: 'item',
          isJob: true,
          url: '/drawings',
          icon: <IconGeometry size={22} />,
        },
        {
          id: 'submittals',
          title: 'Submittals',
          requiredScopes: ['jobs_all', 'jobs_submittals'],
          type: 'item',
          isJob: true,
          url: '/submittals',
          icon: <IconArrowsDiff size={22} />,
        },
      ],
    },
    {
      id: 'group-job-settings',
      title: 'Job Settings',
      type: 'group',
      children: [
        {
          id: 'project_team',
          title: 'Project Team',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_team'],
          type: 'item',
          isJob: true,
          url: '/team',
          icon: <IconUsers size={22} />,
        },
        {
          id: 'wbs',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_wbs'],
          title: 'WBS',
          type: 'item',
          isJob: true,
          url: '/wbs',
          icon: <IconBinaryTree2 size={22} />,
        },
        {
          id: 'workflows',
          title: 'Workflows',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_workflows'],
          type: 'item',
          isJob: true,
          url: '/workflows',
          icon: <IconSitemap />,
        },
        {
          id: 'templates',
          title: 'Templates',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_templates'],
          type: 'item',
          isJob: true,
          url: '/templates',
          icon: <IconFileDescription size={22} />,
        },
        {
          id: 'design_models',
          title: 'Design Models',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_design_models'],
          type: 'item',
          isJob: true,
          url: '/design-models',
          icon: <IconCube size={22} />,
        },
        {
          id: 'rate_sheet',
          title: 'Rate Sheet',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_rates'],
          type: 'item',
          isJob: true,
          url: '/rates',
          icon: <IconUserDollar size={22} />,
        },
        {
          id: 'questions',
          title: 'Questions',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_questions'],
          type: 'item',
          isJob: true,
          url: '/questions',
          icon: <IconHelp size={22} />,
        },
        {
          id: 'hyperlinks',
          title: 'Hyperlinks',
          requiredScopes: ['jobs_settings_all', 'jobs_settings_hyperlinks'],
          type: 'item',
          isJob: true,
          url: '/hyperlinks',
          icon: <IconLink size={22} />,
        },
      ],
    },
  ],
};
